import { render, staticRenderFns } from "./alarmDetailDialog.vue?vue&type=template&id=4927aca4&scoped=true"
import script from "./alarmDetailDialog.vue?vue&type=script&lang=js"
export * from "./alarmDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4927aca4",
  null
  
)

export default component.exports